<div class="package__option">
    <span>Ada juga pilihan paket Halo+ lainnya</span>

    <div class="option__list">
        @for (item of categoryHaloPackageData(); track $index) {
            <button type="button" (click)="getHaloPackage(item.menu_level)" [class.active]="categoryActive() === item.menu_level" class="option">{{item.category_name}}</button>
        }
    </div>

    <div class="package__list">
        @for (item of haloPackageData(); track $index) {
            <app-package-card (click)="onCickPackage(item)" (keydown)="onCickPackage(item)" [data]="handlePackageCardData(item)"/>
        }
    </div>
</div>